export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_14.85c2a4ce.jpg";